// Libraries
var React = require('react');
var $ = require('jquery');

// Styles
require('./Async.scss');

// Assets
var spinner = require('images/Rolling.svg');

// this module allows the .NET site to asynchronously render react components 
// by delaying the creation of the json data structure until after the browser page has loaded
class AsyncModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showError: false,
			isLoading: true
		}
	}

	componentDidMount() {
		this.allModules = global.Components;

		$.ajax({
			method: "GET",
			url: this.props.data.endpoint
		})
		.done(data => {
			this.setState({ json: data, isLoading: false });
		})
		.fail(data => {
			this.setState({ showError: true, isLoading: false });
		});
	}

	render() {
		return (
			<div className="Async">
				{this.state.isLoading &&
					<img src={spinner} className="spinner" alt="Loading..." />
				}

				{!this.state.isLoading && !this.state.json &&
					<p>An error occurred loading module</p>
				}

				{this.state.json &&
					React.createElement(this.allModules[this.state.json.reactModuleName], { "data": this.state.json })
				}
			</div>
		)
	}
}

module.exports = AsyncModule;



// WEBPACK FOOTER //
// ./src/common/Async/AsyncModule.js